import { TiBeer } from 'react-icons/ti';
import { MdRestaurantMenu } from 'react-icons/md';
import { GiFoodTruck } from 'react-icons/gi';
import FoodTruck from '../icons/FoodTruck';

const iconStyle = {
  paddingRight: '4px',
};

const AMENITY_ICON_COMPONENTS = {
  TiBeer,
  MdRestaurantMenu,
  GiFoodTruck,
  FoodTruck,
};

export function getAmenityIcon(iconName) {
  const IconComponent = AMENITY_ICON_COMPONENTS[iconName];
  if (!IconComponent) {
    return null;
  }
  return <IconComponent style={iconStyle} />;
}

export default AMENITY_ICON_COMPONENTS;
